import { useFocusEffect } from 'expo-router';
import { useRef } from 'react';
import useEvent from 'shared/hooks/useEvent/useEvent';

const useRefreshOnRefocus = (refresh: () => void) => {
  const hasFocusedRef = useRef(false);

  const handleFocus = useEvent(() => {
    if (hasFocusedRef.current) {
      refresh();
    }
    hasFocusedRef.current = true;
  });

  useFocusEffect(handleFocus);
};

export default useRefreshOnRefocus;
